import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
	Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useTicketActions from "../../hooks/useTicketActions";

/**
 * "Finalizar sem atendimento": encerra ticket sem trâmite/tarefa/GLPI (número
 * desconhecido, engano, spam). O motivo (texto livre) é obrigatório e fica no log
 * de atividade. A regra de elegibilidade também é validada no backend.
 */
const QuickCloseDialog = ({ open, onClose, ticket }) => {
	const { t } = useTranslation();
	const { quickClose, loading } = useTicketActions(ticket);
	const [reason, setReason] = useState("");

	useEffect(() => {
		if (open) setReason("");
	}, [open]);

	const handleConfirm = async () => {
		if (!reason.trim()) return;
		const ok = await quickClose(reason);
		if (ok) onClose();
	};

	return (
		<Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
			<DialogTitle>{t("quickClose.title")}</DialogTitle>
			<DialogContent>
				<Typography variant="body2" sx={{ mb: 2 }}>
					{t("quickClose.description")}
				</Typography>
				<TextField
					autoFocus
					multiline
					rows={3}
					fullWidth
					required
					variant="outlined"
					size="small"
					label={t("quickClose.reasonLabel")}
					placeholder={t("quickClose.reasonPlaceholder")}
					value={reason}
					onChange={e => setReason(e.target.value)}
					inputProps={{ maxLength: 500 }}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={loading}>
					{t("quickClose.cancel")}
				</Button>
				<Button
					variant="contained"
					onClick={handleConfirm}
					disabled={!reason.trim() || loading}
				>
					{loading ? t("quickClose.closing") : t("quickClose.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default QuickCloseDialog;
